module.exports = __webpack_public_path__ + "static/media/Intelo-Medium.7a0851c5.ttf";